import React from 'react';

const itens = [
  {
    titulo: 'Plataforma completa',
    texto: 'Rastreamento em tempo real, histórico de percurso, cercas virtuais, bloqueio remoto e relatórios — tudo num painel só.',
    icon: <path d="M3 12a9 9 0 1 0 3-6.7M3 4v5h5" />,
  },
  {
    titulo: 'White label de verdade',
    texto: 'Sua marca, seu domínio, seu painel. O cliente final nunca vê o nome Nivocar.',
    icon: <path d="M12 2 3 6v6c0 5 4 8.5 9 10 5-1.5 9-5 9-10V6l-9-4Z" />,
  },
  {
    titulo: 'Aplicativo com identidade visual neutra',
    texto: 'sem a marca Nivocar. O cliente final não identifica nenhuma marca concorrente.',
    icon: <><rect x="6" y="2" width="12" height="20" rx="2" /><path d="M10 18h4" /></>,
  },
  {
    titulo: 'Integração de Cobranças e Assinaturas',
    texto: 'Cobrança, assinatura recorrente e financeiro dos seus clientes, dentro do mesmo painel.',
    icon: <><rect x="2" y="6" width="20" height="14" rx="2" /><path d="M2 11h20" /></>,
  },
  {
    titulo: 'Equipamentos e chips M2M',
    texto: 'Rastreadores, chips M2M e acessórios homologados na loja exclusiva pra parceiros — ou use seus próprios fornecedores, se preferir.',
    icon: <><circle cx="12" cy="10" r="3" /><path d="M12 21c-4-4.5-7-8-7-11a7 7 0 0 1 14 0c0 3-3 6.5-7 11Z" /></>,
  },
  {
    titulo: 'Infraestrutura em nuvem',
    texto: 'Servidor, backup e segurança por nossa conta — você não precisa investir em infraestrutura própria.',
    icon: <><rect x="3" y="4" width="18" height="7" rx="1.5" /><rect x="3" y="13" width="18" height="7" rx="1.5" /><circle cx="7" cy="7.5" r="0.8" fill="currentColor" /><circle cx="7" cy="16.5" r="0.8" fill="currentColor" /></>,
  },
  {
    titulo: 'Suporte técnico direto',
    texto: 'Você fala com quem constrói o sistema — sem fila de central de atendimento genérica.',
    icon: <><path d="M4 12a8 8 0 1 1 8 8" /><path d="M4 12v3a2 2 0 0 0 2 2h1" /><circle cx="4" cy="12" r="1.5" fill="currentColor" /></>,
  },
  {
    titulo: 'Evolução constante',
    texto: 'A plataforma que não para de melhorar — novas integrações e recursos chegando.',
    icon: <path d="M12 2v4M12 18v4M4.9 4.9l2.8 2.8M16.3 16.3l2.8 2.8M2 12h4M18 12h4M4.9 19.1l2.8-2.8M16.3 7.7l2.8-2.8" />,
  },
];

export default function Diferenciais() {
  return (
    <section id="diferenciais">
      <div className="container">
        <div className="section-head">
          <div className="eyebrow" style={{ justifyContent: 'center' }}>Por que a Nivocar</div>
          <h2>Tudo que uma operadora de rastreamento precisa, numa assinatura só</h2>
          <p>Cada item da lista abaixo é algo que você não vai precisar desenvolver ou administrar sozinho.</p>
        </div>
        <div className="dif-grid">
          {itens.map((it, i) => (
            <div className="dif-card" key={i}>
              <div className="dif-icon">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">{it.icon}</svg>
              </div>
              <h3>{it.titulo}</h3>
              <p>{it.texto}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}